import React from "react";
import { createColumnHelper } from "@tanstack/react-table";
import { PencilSimpleLineIcon } from "@phosphor-icons/react";

import Icon from "components/Icon/Icon";

import CommonTooltip from "components/Tooltip/index";

import {
  CompanyNameCell,
  getFullName,
  getUserPlaceholder,
  renderValue
} from "utils/renderCompanyCell";
import { format } from "date-fns";
import StatusPillButtons from "components/Buttons/StatusPillButtons";
import { LinkText } from "components/SocialLinkDropdown/styled";

const brandColumns = (onEdit) => {
  const columnHelper = createColumnHelper();

  const renderName = (row) => {
    const fullName = renderValue(getFullName(row));
    return (
      <CompanyNameCell
        logo={row?.profile_pic || getUserPlaceholder()}
        name={fullName}
        title={fullName}
      />
    );
  };

  return [
    columnHelper.accessor("creator_user_id", {
      header: "Creator User ID",
      size: 140,
      headerClassName: "table-header mono",
      cellClassName: "table-cell mono",
      enableSorting: false,
      cell: (info) => <>{renderValue(info.getValue())}</>
    }),
    columnHelper.accessor(
      (row) =>
        `${row?.creator_user?.first_name} ${row?.creator_user?.last_name}`,
      {
        id: "name",
        header: "Name",
        size: 200,
        headerClassName: "table-header",
        cellClassName: "table-cell",
        enableSorting: false,
        cell: (info) => {
          const row = info.row.original;

          return renderName(row?.creator_user || {});
        }
      }
    ),
    columnHelper.accessor((row) => row.creator_user.phone_number, {
      id: "phone",
      header: "Phone",
      size: 160,
      headerClassName: "table-header mono",
      cellClassName: "table-cell mono",
      enableSorting: false,
      cell: (info) => {
        const row = info.row.original.creator_user;
        return <>{`+91 ${renderValue(row?.phone_number)}`}</>;
      }
    }),
    columnHelper.accessor("low_follower_review_status", {
      header: "Low Follower Review Status",
      size: 160,
      headerClassName: "table-header mono",
      cellClassName: "table-cell mono",
      enableSorting: false,
      cell: (info) => {
        const value = info.getValue();
        return <StatusPillButtons status={value} />;
      }
    }),
    columnHelper.accessor("instagram_handle", {
      header: "IG Handle",
      size: 160,
      headerClassName: "table-header",
      cellClassName: "table-cell",
      enableSorting: false,
      cell: (info) => (
        <>
          {
            <LinkText
              className="link-text-pointer"
              onClick={() =>
                window.open(
                  `https://www.instagram.com/${info.getValue()}`,
                  "_blank"
                )
              }
            >
              {info.getValue()}
            </LinkText>
          }
        </>
      )
    }),
    columnHelper.accessor("created_at", {
      header: "Created At",
      size: 207,
      headerClassName: "table-header",
      enableSorting: false,
      cellClassName: "table-cell",
      cell: (info) => (
        <>
          {renderValue(
            format(new Date(info.getValue()), "MMM dd, yyyy h:mm a")
          )}
        </>
      )
    }),
    columnHelper.display({
      id: "actions",
      header: "",
      size: 60,
      cellClassName: "actions",
      enableSorting: false,
      cell: (info) => {
        const row = info.row.original;

        return (
          <CommonTooltip theme="dark" tooltipContent="Review Creator">
            <div
              className="hover-actions"
              onClick={() => {
                onEdit(row);
              }}
            >
              <Icon component={PencilSimpleLineIcon} weight="regular" />
            </div>
          </CommonTooltip>
        );
      }
    })
  ];
};

export default brandColumns;
